import React, { useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import { Link } from "react-router-dom";
const AssignTask = () => {
  const [expandedReact, setExpandedReact] = useState(false);
  const [expandedJS, setExpandedJS] = useState(false);
  return (
    <AdminAppBody
    content={
      <div className="container py-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="fw-bold">My Task History</h4>
          <Link to="/mentor-assign-new-task">
            <button className="btn btn-primary">Assign Task</button>
          </Link>
        </div>
        <div className="bg-white rounded shadow-sm p-3 mb-4">
          <div className="row g-2 align-items-center">
            <div className="col-md-6">
              <input type="text" className="form-control" placeholder="Search" />
            </div>
            <div className="col-md-3 d-flex align-items-center">
              <span className="me-2">Filter:</span>
              <select className="form-select">
                <option>Select Type</option>
              </select>
            </div>
          </div>
        </div>
        {/* TaskCard 1 */}
        <div className="bg-white p-3 rounded shadow-sm mb-3">
          <div className="d-flex justify-content-between">
            <div>
              <h5 className="fw-bold mb-1">React</h5>
              <p className="mb-1 text-muted">Topic: Components</p>
              {expandedReact && (
                <>
                  <p className="mb-1 fw-semibold">Tasks:</p>
                  <div className="bg-light rounded p-2 mb-2 w-auto d-inline-block">
                    Create 5 any components
                  </div>
                  <p className="mb-1 fw-semibold">Assigned Students:</p>
                  <div className="d-flex align-items-center mb-2">
                    <div
                      className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: 28, height: 28 }}
                    >
                      S
                    </div>
                    <span>Shubham Ghusalkar</span>
                  </div>
                  <p className="mb-1 fw-semibold">Assigned Groups:</p>
                  <p className="text-muted">No groups</p>
                </>
              )}
            </div>
            <div className="text-end">
              <small className="text-muted">Assigned : 1 month ago</small>
              <div>
                <button
                  className="btn btn-link p-0 mt-2"
                  onClick={() => setExpandedReact(!expandedReact)}
                >
                  {expandedReact ? "See Less ↑" : "See More ↓"}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* TaskCard 2 */}
        <div className="bg-white p-3 rounded shadow-sm mb-3">
          <div className="d-flex justify-content-between">
            <div>
              <h5 className="fw-bold mb-1">JavaScript</h5>
              <p className="mb-1 text-muted">Topic: ES6</p>
              {expandedJS && (
                <>
                  <p className="mb-1 fw-semibold">Assigned Students:</p>
                  <div className="d-flex align-items-center mb-2">
                    <div
                      className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: 28, height: 28 }}
                    >
                      C
                    </div>
                    <span>C</span>
                  </div>
                  <p className="mb-1 fw-semibold">Assigned Groups:</p>
                  <p className="text-muted">No groups</p>
                </>
              )}
            </div>
            <div className="text-end">
              <small className="text-muted">Assigned : 2 months ago</small>
              <div>
                <button
                  className="btn btn-link p-0 mt-2"
                  onClick={() => setExpandedJS(!expandedJS)}
                >
                  {expandedJS ? "See Less ↑" : "See More ↓"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
}/>);
};
export default AssignTask;